import { useState } from "react";
import {
    Box,
    Chip,
    IconButton,
    Tooltip,
    Typography
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import AddItemModal from "./AddItemModal";
import classes from "./MUIMultiItemBox.module.css"
export default function MUIMultiItemBox({
    label,
    value = [],
    onChange,
    max = 3,
    labelKey = "title",
    modalTitle,
    modalFields,
    isDisabled,
    useObjectFormat
}) {
    const [open, setOpen] = useState(false);

    const handleAdd = (item) => {
        if (value.length < max) {
            onChange([...value, item]);
        }
        setOpen(false);
    };

    const handleDelete = (index) => {
        onChange(value.filter((_, i) => i !== index));
    };

    return (
        <>
            {/* 🔹 Field Label */}
            <Typography className={classes.label}>{label}</Typography>
            {/* 🔹 Box */}
            <Box
                sx={{
                    border: "1px solid #ddd",
                    borderRadius: 2,
                    px: 1,
                    py: 0.75,
                    display: "flex",
                    alignItems: "flex-start", 
                    gap: 1,
                    minHeight: 45,
                    width: "100%",
                    minWidth: 0,
                    backgroundColor: isDisabled ? "#f8fafc" : "transparent", 
                    pointerEvents: isDisabled ? "none" : "auto" 
                }}
            >
                {/* Left: Chips */}
                <Box
                    sx={{
                        display: "flex",
                        gap: 1,
                        flexWrap: "wrap",
                        flexGrow: 1,
                        minWidth: 0            
                    }}
                >
                    {value.map((item, index) => (
                        <Chip
                            sx={{
                                mt: 0.5,
                                height: "auto",                 
                                maxWidth: "100%",               
                                "& .MuiChip-label": {
                                    whiteSpace: "normal",         
                                    wordBreak: "break-word",
                                    lineHeight: 1.3,
                                    paddingTop: "4px",
                                    paddingBottom: "4px"
                                }
                            }}
                            key={index}
                            label={typeof item == "string" ? item : item[labelKey]}
                            onDelete={
                                isDisabled ? undefined : () => handleDelete(index)
                            }
                        />
                    ))}
                </Box>

                {/* Right: Add Button */}
                {value.length < max && !isDisabled && (
                    <Tooltip title="Add">
                        <IconButton
                            size="small"
                            onClick={() => setOpen(true)}
                            sx={{
                                border: "1px dashed #aaa",
                                width: 32,
                                height: 32,
                                mt: 0,
                                marginTop: "0px !important",
                            }}
                        >
                            <AddIcon fontSize="small" />
                        </IconButton>
                    </Tooltip>
                )}

                {/* Counter */}
                <Typography
                    variant="caption"
                    sx={{
                        color: "text.secondary",
                        lineHeight: 1,
                        mt: 1
                    }}
                >
                    {value.length}/{max}
                </Typography>

            </Box>

            {/* Modal */}
            <AddItemModal
                open={open}
                onClose={() => setOpen(false)}
                onSave={handleAdd}
                title={modalTitle}
                fields={modalFields}
                useObjectFormat={useObjectFormat}
            />
        </>
    );
}